<template>
  <div class="main">
    <div class="container">
      <div class="category menu-item mx-4 px-2" id="dropdownCategory">
        <div>
          ประเภทสินค้า <span class="fas fa-chevron-down ml-2"></span>
        </div>
        <div class="dropdown-menu">
          <router-link :to="{ path: '/list', query: { category: 'best-seller'} }">
            <a class="dropdown-item">สินค้าขายดี</a>
          </router-link>
          <router-link :to="{ path: '/list', query: { category: 'smart-building'} }">
            <a class="dropdown-item">Smart Building</a>
          </router-link>
          <router-link :to="{ path: '/list', query: { category: 'smart-room'} }">
            <a class="dropdown-item">Smart Room</a>
          </router-link>
          <router-link :to="{ path: '/list', query: { category: 'smart-manage' } }">
            <a class="dropdown-item">Smart Management</a>
          </router-link>
          <router-link :to="{ path: '/list', query: { category: 'smart-service' } }">
            <a class="dropdown-item">Smart Service</a>
          </router-link>

          <hr class="p-1 m-1 d-block d-md-none">
          
          <router-link :to="{ path: '/list' }">
            <a class="dropdown-item d-block d-md-none">สินค้าทั้งหมด</a>
          </router-link>
          <router-link :to="{ path: '/list', query: { type: 'new' } }">
            <a class="dropdown-item d-block d-md-none">สินค้าใหม่</a>
          </router-link>
          
        </div>
      </div>
      <router-link to="/" class="menu-item mx-4 px-2" :class="$route.fullPath == '/' ? 'active' : ''">
        หน้าหลัก
      </router-link>
      <router-link to="/list" class="menu-item mx-4 px-2 d-none d-md-inline-block" :class="$route.fullPath == '/list' ? 'active' : ''">
        สินค้าทั้งหมด
      </router-link>
      <router-link :to="{ path: '/list', query: { type: 'new' } }" class="menu-item mx-4 px-2 d-none d-md-inline-block" :class="$route.fullPath == '/list?type=new' ? 'active' : ''" >
        สินค้าใหม่
      </router-link>
      <div class="menu-item mx-4 px-2 accounting" id="dropdownAccount" v-if="user">
        <div>
          บัญชี <span class="fas fa-chevron-down ml-2"></span>
        </div>
        <div class="dropdown-menu dropdown-account-menu">
          <router-link to="/user/address">
            <a class="dropdown-item"><i class="fas fa-map-marker-alt"/> ที่อยู่การจัดส่ง</a>
          </router-link>
          <router-link to="/user/orderhistory">
            <a class="dropdown-item"><i class="fas fa-history"/> ประวัติการสั่งซื้อ</a>
          </router-link>
          <router-link to="/user/trackingorder">
            <a class="dropdown-item"><i class="fas fa-truck-loading"/> ติดตามสินค้า</a>
          </router-link>
        </div>
        <!-- <div class="dropdown-menu dropdown-account-menu" v-else style="height: 80px">
          <a :href="`${$webAppUrl}/login?redirect=marketplace`" class="dropdown-item" target="_blank">เข้าสู่ระบบ</a>
          <a :href="`${$webAppUrl}/pre-signup?utm_source=marketplace`" class="dropdown-item">สมัครสมาชิก</a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed:{
    ...mapState([
      'user'
    ]),
  },
  data(){
    return {
      path: this.$route
    }
  },
}
</script>
<style scoped>
.navbar{
  height: 53px;
  /* position: sticky; */
  /* background-color: rgb(240, 240, 240); */
  margin-bottom: 15px;
  border: 1px solid black;
  padding-top: 5px;
}
.main{
  position: fixed;
  width: 100%;
  /* max-width: 1300px; */
  left: 50%;
  transform: translate(-50% , 0);
  z-index: 16;
  padding-top: 6px;
  background-color: white;
  box-shadow: 0px 0px 4px black;
  height: 62px;
  margin-top: -6px;
}
.container{
  max-width: 1300px;
  position: relative;
}
.category .dropdown-menu{
  height: 0;
  opacity: 0;
  display: block;
  transition: all 300ms;
  transform: translateX(20%);
}
.category:hover .dropdown-menu {
  height: 180px;
  opacity: 1;
}
.accounting .dropdown-menu{
  height: 0;
  opacity: 0;
  display: block;
  transition: all 300ms;
  transform: translateX(-50%);
}
.accounting:hover .dropdown-account-menu {
  height: 120px;
  opacity: 1;
}
.dropdown-menu{
  border: 1px solid rgba(148, 148, 148, 0.5);
  cursor: pointer;
  color: rgb(69, 69, 69);
  z-index: 15;
  margin-top: -5px;
}
.dropdown-menu a{
  text-decoration: none;
  color: rgb(69, 69, 69);
}
.dropdown-item:active{
  background: rgb(186, 186, 186);
  z-index: 15;
}
.menu-item{
  display: inline-block;
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
  transition: all 200ms;
  text-decoration: none;
  color: rgb(69, 69, 69);
}
.menu-item:hover{
  background-color: rgba(0, 0, 0, 0.05);
}
.menu-item.active{
  border-bottom: 5px solid  #e9773b;
}
.menu-item.accounting{
  position: absolute;
  right: 0;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  .menu-item{
    font-size: 14px;
  }
  .category:hover .dropdown-menu {
    height: 230px;
    opacity: 1;
  }
}
</style>